export default __webpack_public_path__ + "static/media/H0007.7808200a.png";